export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20display%20featuring%20neatly%20arranged%20sneakers%20designer%20handbags%20and%20accessories%20on%20warm%20wooden%20shelving%20with%20soft%20ambient%20showroom%20lighting%2C%20luxurious%20boutique%20interior%20with%20cream%20marble%20floors%20and%20brass%20fixtures%2C%20rich%20textural%20details%20of%20leather%20suede%20and%20woven%20fabrics%2C%20sophisticated%20upscale%20shopping%20environment%20with%20natural%20light%20streaming%20through%20large%20windows&width=1800&height=1200&seq=hero-bg-v4-fashion-boutique&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40 z-[1]"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 pt-28 md:pt-36 pb-24">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-accent-500/90 text-white text-[12px] font-semibold rounded-full uppercase tracking-wider mb-6">
              Updated Daily · Community Trusted
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] tracking-tight">
              Best Sugargoo Spreadsheet
              <br />
              <span className="text-accent-300">2026</span>
            </h1>
            <p className="mt-6 text-[15px] md:text-[17px] text-white/85 max-w-xl mx-auto lg:mx-0 font-medium leading-relaxed">
              Discover the most updated Sugargoo Spreadsheet for sneakers, clothing, accessories, and budget finds. Curated daily by the community, organized for easy browsing.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 bg-accent-500 text-white font-bold text-[14px] rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/30"
              >
                Sugargoo Spreadsheet
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 border-2 border-white/70 text-white font-bold text-[14px] rounded-full hover:bg-white hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-shopping-bag-line ml-2"></i>
              </a>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-6 justify-center lg:justify-start text-white/70 text-[13px] font-medium">
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i> Updated Daily
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i> 14+ Categories
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-400"></i> Community Trusted
              </span>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-md">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-white/20">
                <h3 className="text-white font-heading text-xl font-bold mb-4">Browse Categories</h3>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
                    { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
                    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
                    { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
                    { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
                    { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
                    { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
                    { name: 'Underwear', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
                    { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
                    { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
                    { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
                    { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
                    { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
                    { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
                  ].map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="px-3 py-2 text-[13px] font-medium text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-all text-center whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}